import { render, staticRenderFns } from "./PendingSwap.vue?vue&type=template&id=5fdf7b4d&scoped=true"
import script from "./PendingSwap.vue?vue&type=script&lang=js"
export * from "./PendingSwap.vue?vue&type=script&lang=js"
import style0 from "./PendingSwap.vue?vue&type=style&index=0&id=5fdf7b4d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf7b4d",
  null
  
)

export default component.exports